/**
 * Data attribute used to identify the render root element.
 * This allows resource links to be placed outside the render boundary.
 */
export const SFS_RENDER_ROOT = "data-sfs-webpart-render-root";
